import React from "react";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";

const toTestId = (label: string): string =>
    `financial-document-details-${label.toLowerCase().replace(/\s+/g, "-")}`;

export const MetadataItem: React.FC<
    Readonly<{ label: string; children: React.ReactNode }>
> = ({ label, children }) => (
    <DescriptionListItem
        layout="stack"
        label={label}
        valueTestId={toTestId(label)}
    >
        {children}
    </DescriptionListItem>
);
